import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import apis from '@/api/index.js'

Vue.config.productionTip = false;
Vue.use(apis)

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
